import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import { use } from "i18next";
import { Settings } from "../../Constant";

function Edit(props) {
  document.title = "charger | Edits";
  const [charger, setCharger] = useState(null);
  const params = useParams();
  let ChargerID = params.cid;
  let navigate = useNavigate();
  let location = useLocation();
   let ChargerEditData = location?.state?.ChargerEditData;
   console.log("ChargerEditData", ChargerEditData);

   const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/chargers/details/${ChargerID}`;
    
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
  
      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setCharger(res.data.data[0]); // Set the first item in the data array
      } else {
        console.error("No charger data found");
      }
    } catch (error) {
      console.error("Error fetching charger data:", error);
    }
  }
  

  useEffect(() => {
    fetchData();
  }, []);
  console.log("chargerData", charger);


  // Destructure the data passed from the previous component
  // const UserEditData = location?.state?.UserEditData;

  // Log to ensure StationEditData is availabl

  // State variables
  const [Name, setName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [loading, setLoading] = useState(false);
  const [VehicleNumber, setVehicleNumber] = useState([]);
  const [selectedParent, setselectedParent] = useState([]);
  const [userType, setUserType] = useState([]);
  const [LatitudePoints, setLatitudePoints] = useState([]);
  const [LongitudePoints, setLongitudePoints] = useState("");
  const [IMEINumber, setIMEINumber] = useState([]);
  const [AmarRajaChargerID, setAmarRajaChargerID] = useState([]);
  const [simNumber, setSimNumber] = useState([]);
  const [ChipID, SetChipID] = useState([]);
  const [BookingAmount, setBookingAmount] = useState([]);
  const [BookingCancelAmount, setBookingCancelAmount] = useState([]);
  const [ChargerEstimatedBidPrice, setChargerEstimatedBidPrice] = useState([]);
  const [Address, setAddress] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [Tax, setTax] = useState([]);
  const [othercharges, setothercharges] = useState([]);
  const [PerUnitPricewithoutGST, setPerUnitPricewithoutGST] = useState([]);
  const [PerUnitPricewithGST, setPerUnitPricewithGST] = useState([]);
  const [LocalHourse, setLocalHourse] = useState([]);
  const [SecurityCode, setSecurityCode] = useState([]);
  const [ChargerconType, setChargerconType] = useState([]);
  const [ConnectorsType, setConnectorsType] = useState([]);
  const [Power, setPower] = useState([]);
  const [SelectServiceProvider, setSelectServiceProvider] = useState([]);
  const [selectAmenity, setselectAmenity] = useState([]);
  const [SelectVechicle, setSelectVechicle] = useState([]);
  const [PaymentType, setPaymentType] = useState([]);
  const [ChargerType, setChargerType] = useState([]);
  const [Maxvoltage, setMaxvoltage] = useState([]);
  const [Maxcurrent, setMaxcurrent] = useState([]);
  const [MinimumCOneValue, setMinimumCOneValue] = useState([]);
  const [stationName, setStationName] = useState([]);
  const [ChargerData, setChargerData] = useState([]);
  const [PowerListing, setPowerListing] = useState([]);
  const [AmenitiesTypes, setAmenitiesTypes] = useState([]);
  const [Vehiclesnames, setVehiclesnames] = useState([]);
  const [chargingTypesData, setchargingTypesData] = useState([]);

  // Populate form fields with existing data on load


  // Handlers for form fields
  const handleName = (e) => setName(e.target.value);
  const handleLatitudePoints = (e) => setLatitudePoints(e.target.value);
  const handleLongitudePoints = (e) => setLongitudePoints(e.target.value);
  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);
  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleIMEINumberChange = (e) => setIMEINumber(e.target.value);
  const handleAmarRajaPoints = (e) => setAmarRajaChargerID(e.target.value);
  const handleSimNumberChange = (e) => setSimNumber(e.target.value);
  const handleChipNumberChange = (e) => SetChipID(e.target.value);
  const handleBookingAmountChange = (e) => setBookingAmount(e.target.value);
  const handlecancelBookingAmountChange = (e) => setBookingCancelAmount(e.target.value);
  const handleChargerEstimatedBidPriceChange = (e) => setChargerEstimatedBidPrice(e.target.value);
  const handletaxChange = (e) => setTax(e.target.value);
  const handleotherchargesChange = (e) => setothercharges(e.target.value);
  const handlePerUnitPricewithoutGSTChange = (e) => setPerUnitPricewithoutGST(e.target.value);
  const handlePerUnitPricewithGSTChange = (e) => setPerUnitPricewithGST(e.target.value);
  const handleLocalHourseChange = (e) => setLocalHourse(e.target.value);
  const handleSecurityCodeChange = (e) => setSecurityCode(e.target.value);
  const handleChargerconTypeChange = (e) => setChargerconType(e.target.value);
  const handleConnectorsTypeChange = (e) => setConnectorsType(e.target.value);
  const handlePowerChange = (e) => setPower(e.target.value);
  const handleServiceProviderChange = (e) => setSelectServiceProvider(e.target.value);
  const handleAmenityChange = (e) => setselectAmenity(e.target.value);
  const handleVechicleChange = (e) => setSelectVechicle(e.target.value);
  const handlePaymentTypeChange = (e) => setPaymentType(e.target.value);
  const handleChargerTypeChange = (e) => setChargerType(e.target.value);
  const handleMaxvoltageChange = (e) => setMaxvoltage(e.target.value);
  const handleMaxcurrentChange = (e) => setMaxcurrent(e.target.value);
  const handleMinimumCOneValueChange = (e) => setMinimumCOneValue(e.target.value);
  const handleStationNameChange = (e) => setStationName(e.target.value);
  const handleUserTypeChange = (e) => setUserType(e.target.value);
  const handleStatusType = (e) => setSelectedStatusType(e.target.value);

  useEffect(() => {
    if (charger) {
      setName(charger?.charger?.charger_name);
      setAddress(charger?.address);
      setSelectedStatusType(charger?.status);
      setLatitudePoints(charger?.latitude);
      setLongitudePoints(charger?.longitude);
      setChargerType(charger?.charger?.master_charger_type_id);
      setPower(charger?.charger?.select_power_str);
      setSelectServiceProvider(charger?.charger?.service_provider_str);
      setselectAmenity(charger?.charger?.select_amenity_str);
      setVehicleNumber(charger?.charger?.select_vehicle_str);
      setIMEINumber(charger?.charger?.imei_number);
      setAmarRajaChargerID(charger?.charger?.AmarRaja_charger_id);
      SetChipID(charger?.charger?.chip_id);
      setSimNumber(charger?.charger?.sim_number);
      setTax(charger?.charger?.tax);
      setLocalHourse(charger?.charger?.local_hours);
      setBookingAmount(charger?.charger?.booking_amount);
      setBookingCancelAmount(charger?.charger?.booking_cancel_amount)
      setStationName(charger?.station_name);
    setMaxvoltage(charger?.charger?.max_voltage);
    setMaxcurrent(charger?.charger?.max_current);
    setChargerEstimatedBidPrice(charger?.charger?.charger_estimated_bid_price);
    setPerUnitPricewithGST(charger?.charger?.per_unit_price_with_gst);
    setPerUnitPricewithoutGST(charger?.charger?.per_unit_price_without_gst);
    setSecurityCode(charger?.charger?.security_code);
    setothercharges(charger?.charger?.other_charger);
    setMinimumCOneValue(charger?.charger?.minimum_c_one_value)
    setSelectedFile(charger?.charger?.station_image);

      // setAuthorNames(charger?.author);
      // setSubjectCode(charger?.subject_code);
      // setPrice(charger?.price);
      // setQuantity(charger?.quantity);
      // setRackNo(charger?.rack);
    }
  }, [charger]);
  const FetchChargerData = async () => {
    setLoading(true);

    try {
      const res = await request({
        url: `${BaseURL}/master/charger-type-0`,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      if (res && res?.data) {

        setChargerData(res?.data);
      } else {
        setChargerData([]); // If no data, ensure filteredData is empty
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setChargerData([]); // In case of error, set filteredData to empty
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchChargerData();
  }, []);




  useEffect(() => {
    // Fetch countries on component mount
    const fetchPowerListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/power-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setPowerListing(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchPowerListing();
  }, []);
  useEffect(() => {
    // Fetch countries on component mount
    const fetchAmenityListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/amenites-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setAmenitiesTypes(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchAmenityListing();
  }, []);
  useEffect(() => {
    // Fetch countries on component mount
    const fetchVehicleNamesListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/vehicles-name-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setVehiclesnames(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchVehicleNamesListing();
  }, []);













  // Function to handle the update request
  const UpdateCharger= async () => {


    // Create a new FormData object
    let formData = new FormData();
    formData.append("charger_name", Name);
    formData.append("status", selectedStatusType);
    formData.append("imei_number", IMEINumber);
    formData.append("AmarRaja_charger_id", AmarRajaChargerID);
    formData.append("sim_number", simNumber);
    formData.append("chip_id", ChipID);
    formData.append("booking_amount", BookingAmount);
    formData.append("booking_cancel_amount", BookingCancelAmount);
    formData.append("charger_estimated_bid_price", ChargerEstimatedBidPrice);
    formData.append("tax", Tax);
    formData.append("other_charger", othercharges);
    formData.append("per_unit_price_without_gst", PerUnitPricewithoutGST);
    formData.append("per_unit_price_with_gst", PerUnitPricewithGST);
    formData.append("local_hours", LocalHourse);
    formData.append("security_code", SecurityCode);
    // formData.append("charger_conn_type", ChargerconType);
    formData.append("max_voltage", Maxvoltage);
    formData.append("max_current", Maxcurrent);
    formData.append("minimum_c_one_value", MinimumCOneValue);
    formData.append("select_amenity_id", selectAmenity);
    formData.append("select_power_id", Power);
    // formData.append("payment_type_id", "1234");
    formData.append("master_charger_type_id", ChargerType);
    formData.append("select_vehicle_id", SelectVechicle);
    formData.append("master_station_charger_id", ChargerType)


    if (selectedFile) {
      formData.append("charger_image", selectedFile);
    }


    try {
      // Make the API request
      let response = await axios.put(
        `${BaseURL}/chargers/edit/${ChargerID}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            // 'Content-Type' is automatically set by axios when using FormData
          },
        }
      );

      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response?.data?.message,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/chargers`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to update station. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      console.error("Error in EditStation:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Edit Chargers
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr style={{ marginTop: "-10px" }} />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                              Charger Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleName}
                                value={Name}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="latitude_id" className="col-sm-2 control-label">
                              Address
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleAddressChange}
                                value={Address}
                                className="form-control"
                                id="latitude_id"
                                name="latitude"

                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Latitude
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="email"
                                onChange={handleLatitudePoints}
                                value={LatitudePoints}
                                className="form-control"
                                id="email"
                                name="email"

                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Longitude
                            </label>
                            <div className="col-sm-6">
                              <input
                                id="country"
                                className="form-control"

                                onChange={handleLongitudePoints}
                                value={LongitudePoints}
                              />


                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              IMEI Number
                            </label>
                            <div className="col-sm-6">
                              <input
                                id="state"
                                className="form-control"
                                  value={IMEINumber}
                                onChange={handleIMEINumberChange}

                              >

                              </input>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              AmarRaja Charger ID
                            </label>
                            <div className="col-sm-6">
                              <input
                                id="city"
                                className="form-control"
                                value={AmarRajaChargerID}
                                onChange={handleAmarRajaPoints}

                              />


                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Sim Numnber
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="text"
                                onChange={handleSimNumberChange}
                                value={simNumber}
                                className="form-control"
                                id="VehicleNumber"
                                name="VehicleNumber"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Chip ID
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleChipNumberChange}
                                value={ChipID}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Booking Amount
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleBookingAmountChange}
                                value={BookingAmount}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Booking Cancel Amount
                            </label>
                            <div className="col-sm-6">
                              <input
                              value={BookingCancelAmount}
                                onChange={handlecancelBookingAmountChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger Estimated Bid Price
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleChargerEstimatedBidPriceChange}
                                 value={ChargerEstimatedBidPrice}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Tax
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handletaxChange}
                                value={Tax}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Other Charges
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleotherchargesChange}
                                value={othercharges}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Per Unit Price without GST
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePerUnitPricewithoutGSTChange}
                                 value={PerUnitPricewithoutGST}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Per Unit Price with GST
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePerUnitPricewithGSTChange}
                                value={PerUnitPricewithGST}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Local Hourse
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleLocalHourseChange}
                                 value={LocalHourse}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Security Code
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleSecurityCodeChange}
                                value={SecurityCode}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger con Type
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleChargerconTypeChange}
                                value={ChargerconType}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Connectors Type
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleConnectorsTypeChange} 
                                     value={ConnectorsType}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Power
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handlePowerChange}
                                 value={Power}
                                className="form-control"
                                id="address_id"
                                name="address"
                              >
                                <option value="0">Select Power</option>
                                {PowerListing?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Service Provider
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleServiceProviderChange}
                                   value={SelectServiceProvider}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Amenity
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleAmenityChange}
                                   value={selectAmenity}
                                className="form-control"
                                id="address_id"
                                name="address"
                              >
                                <option value="0">Select Amenity</option>
                                {AmenitiesTypes?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Vehicle
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleVechicleChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              >
                                <option value="0">Select Vehicle</option>
                                {Vehiclesnames?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Payment Type
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePaymentTypeChange}
                                   value={PaymentType}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger Type
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleChargerTypeChange}
                                   value={ChargerType}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Max Voltage
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMaxvoltageChange}
                          value={Maxvoltage}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Max Current
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMaxcurrentChange}
                  value={Maxcurrent}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Minimum C One Value
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMinimumCOneValueChange}
                                value={MinimumCOneValue}
                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                  

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="file_id" className="col-sm-2 control-label">
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="file"
                                onChange={handleFileChange}
                                className="form-control"
                                id="file_id"
                                name="user_image"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="statusType" className="col-sm-2 control-label">
                              Status
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleStatusType}
                                value={selectedStatusType}
                                type="text"
                                className="form-control"
                                id="statusType"
                                name="statusType"
                              >
                                <option value="0">Select Status</option>
                                <option value="Active">Active</option>
                                <option value="Inactive">Inactive</option>
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>



                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={UpdateCharger}
                              value="Update Charger"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Edit;
